// src/pages/FundPlanner/components/Funds/investmentTypes.js

export const TYPE_OPTIONS = [
  { value: "Bank Deposit", label: "Bank Deposit" },
  { value: "Cash", label: "Cash" },
  { value: "CD", label: "CD" },
  { value: "Commercial Paper", label: "Commercial Paper" },
  { value: "Corporate Bond", label: "Corporate Bond" },
  { value: "LGIP", label: "LGIP" },
  { value: "Money Market Funds", label: "Money Market Funds" },
  { value: "Municipal Bond", label: "Municipal Bond" },
  { value: "Repo / Investment Contract", label: "Repo / Investment Contract" },
  { value: "SLGS Demand Deposit", label: "SLGS Demand Deposit" },
  { value: "SLGS Time Deposit", label: "SLGS Time Deposit" },
  { value: "US Agency", label: "US Agency" },
  { value: "US Agency - Callable", label: "US Agency - Callable" },
  { value: "US Treasury", label: "US Treasury" },
];

export const TYPE_VALUES = TYPE_OPTIONS.map((opt) => opt.value);

export const TYPE_VALUE_SET = new Set(TYPE_VALUES);

export const CUSIP_TYPE_VALUES = [
  "US Treasury",
  "US Agency",
  "US Agency - Callable",
  "Commercial Paper",
  "Corporate Bond",
  "Municipal Bond",
];

export const CUSIP_TYPE_SET = new Set(CUSIP_TYPE_VALUES);

export function isCusipInvestmentType(value) {
  return CUSIP_TYPE_SET.has(value);
}

export function isMoneyMarketFundInvestmentType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "mmf" ||
    normalized === "money market fund" ||
    normalized === "money market funds" ||
    normalized === "money market"
  );
}

export function requiresInitialBalanceAmount(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "bank deposit" ||
    normalized === "cash" ||
    normalized === "lgip" ||
    normalized === "mmf" ||
    normalized === "money market fund" ||
    normalized === "money market funds" ||
    normalized === "money market" ||
    normalized === "slgs demand deposit" ||
    normalized === "demand deposit"
  );
}

export function normalizeInitialPositionAmount(investmentType, value) {
  return requiresInitialBalanceAmount(investmentType) &&
    (value == null || String(value).trim() === "")
    ? 0
    : value;
}

export function isShortTermInvestmentType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "bank deposit" ||
    normalized === "cash" ||
    normalized === "lgip" ||
    normalized === "mmf" ||
    normalized === "money market fund" ||
    normalized === "money market funds" ||
    normalized === "money market"
  );
}

export function isTransferEligibleInvestmentType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "bank deposit" ||
    normalized === "cash" ||
    normalized === "lgip" ||
    normalized === "mmf" ||
    normalized === "money market fund" ||
    normalized === "money market funds" ||
    normalized === "money market"
  );
}

export function isInterestReinvestmentInvestmentType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "bank deposit" ||
    normalized === "bank deposit / cd" ||
    normalized === "cd" ||
    normalized === "lgip" ||
    normalized === "mmf" ||
    normalized === "money market fund" ||
    normalized === "money market funds" ||
    normalized === "money market"
  );
}

export function isEffectiveYieldOverrideInvestmentType(value) {
  const normalized = String(value ?? "").trim().toLowerCase();
  return normalized === "bank deposit";
}
